export default {
  namespaced: true,
  brigades: {
    title: "Brigada | Brigadas",
    name: "Nome",
    division: "Divisão",
    floor: "Andar",
    type_category: "Categoria",
    number_floors: "Número de Andares",
    capacity: "Capacidade",
    role: "Função",
    user: "Usuário",
    filter_by_floor: "Filtrar por Andar",
    filter_by_role: "Filtrar por função",
    filter_by_search: "Buscar",
    filter_by_search_placeholder: "Usuário ou SOEID",
    status: "Status",
    courses_uploaded: "Cursos enviados",
    courses_skipped: "Cursos ignorados",
  },
};